import { parseDimensions } from '@/lib/utils/dimensions';

/** An unqualified value such as 90x60 is ambiguous across product families. */
export function dpiProductSize(value: unknown, label?: unknown): { widthMm: number; heightMm: number } | null {
  for (const candidate of [label, value]) {
    if (typeof candidate !== 'string' || !candidate.trim()) continue;
    if (!/(?:\d[\s_]*(?:cm|mm|inches|inch|in)\b|\d\s*"|\b(?:A[0-6]|B1)\b)/i.test(candidate)) continue;
    const parsed = parseDimensions(candidate);
    if (parsed && parsed.width > 0 && parsed.height > 0) return { widthMm: parsed.width, heightMm: parsed.height };
  }
  return null;
}
